// Angular
import { InjectionToken } from '@angular/core';
// NgRx Store
import { StoreConfig, createReducer, on, createAction, props, createSelector } from '@ngrx/store';
// Constants
import { FREE_SEARCH_OPTIONS } from '@constants';
// NgRx
export const selectFTSState = (state: any) => state.fts;

// Meta-reducer configuration token
export const FEATURE_FTS_TOKEN = new InjectionToken<StoreConfig<any>>('FTS Feature Token');

// Token for the local storage keys.
export const FTS_LS_KEY = new InjectionToken<string[]>('FTS LocalStoreKeys');

// SELECTOR
export const currentFTS = createSelector(selectFTSState, fts => fts);

// ACTIONS
export const saveFts = createAction(
    '[FTS] Save',
    props<{ searchOption: number; searchText: string }>()
)

// INTERFACE
export interface FtsAppState {
    searchOption: number;
    searchText: string;
}

// INITIAL STATE
export const initialState: FtsAppState = {
    searchOption: FREE_SEARCH_OPTIONS[0]?.value,
    searchText: '',
}

// REDUCER
export const ftsReducer = createReducer(
    initialState,
    on(saveFts, (state, action) => ({ ...state, searchOption: action.searchOption, searchText: action.searchText }))
)

